export default __webpack_public_path__ + "static/media/bubble_wrap.cf15dc4d.png";